import {
  Button,
  ButtonGroup,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  useToast,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { useTenant } from '@/hooks/use-tenant';
import { useUser } from '@/lib/auth';
import { useSettingMfa } from '@/lib/mfa';
import { queryClient } from '@/lib/react-query';

type MfaSettingModalsProp = {
  isOpen: boolean;
  onClose: () => void;
  isPasswordChangeFormModalOpen: boolean;
  onPasswordChangeFormModalClose: () => void;
  onPasswordChangeCancelModalOpen: () => void;
};

export const MfaSettingModals = (props: MfaSettingModalsProp) => {
  console.info('mfa-setting-modal.tsx_1');
  const user = useUser();
  const tenant = useTenant();
  const { enableMfa, disableMfa } = useSettingMfa();
  const [mfaSetting, setMfaSetting] = useState<'enabled' | 'disabled'>(
    user.data?.mfa_needed ? 'enabled' : 'disabled',
  );
  const {
    isOpen,
    onClose,
    isPasswordChangeFormModalOpen,
    onPasswordChangeFormModalClose,
    onPasswordChangeCancelModalOpen,
  } = props;
  useEffect(() => {
    if (user.data?.mfa_needed) {
      console.info('mfa-setting-modal.tsx_2');
      setMfaSetting('enabled');
    } else {
      console.info('mfa-setting-modal.tsx_3');
      setMfaSetting('disabled');
    }
  }, [user.data]);

  const handleChangeModal = (value: string) => {
    console.info('mfa-setting-modal.tsx_4');
    if (value === 'mfa') {
      console.info('mfa-setting-modal.tsx_5');
      return;
    }
    console.info('mfa-setting-modal.tsx_6');
    onClose();
  };
  const toast = useToast();
  const mfa_enable_success_toast = () => {
    console.info('mfa-setting-modal.tsx_7');
    toast({
      title: '二段階認証を有効にしました。',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };
  const mfa_disable_success_toast = () => {
    console.info('mfa-setting-modal.tsx_8');
    toast({
      title: '二段階認証を無効にしました。',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };
  return (
    <Modal
      isOpen={isOpen && isPasswordChangeFormModalOpen}
      onClose={onPasswordChangeCancelModalOpen}
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
      <ModalContent>
        <ModalHeader bg="white" color="black"></ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" fontSize="xl">
            パスワード設定
          </Text>
          <RadioGroup
            defaultValue="mfa"
            onChange={(value) => handleChangeModal(value)}
          >
            <Radio value="password" px={4} py={2}>
              パスワード変更
            </Radio>
            <Radio value="mfa" px={4} py={2}>
              二段階認証設定
            </Radio>
          </RadioGroup>
          <Text fontWeight="bold" fontSize="xl" mt={4} mb={2}>
            二段階認証設定
          </Text>
          <Text fontSize="sm" color="gray.500">
            有効にすると、ログイン時にメールで送られる認証コードが必要になります。
            <br />
            これにより、第三者による不正ログインを防ぎ、セキュリティが強化されます。
            <br />
            また、有効化した際には一度ログアウトされます。
          </Text>
          <RadioGroup
            value={mfaSetting}
            onChange={(value) => setMfaSetting(value as 'enabled' | 'disabled')}
          >
            <Radio value="enabled" px={4} py={2}>
              有効
            </Radio>
            <Radio value="disabled" px={4} py={2}>
              無効
            </Radio>
          </RadioGroup>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup spacing={4}>
            <Button
              onClick={onPasswordChangeCancelModalOpen}
              colorScheme="gray"
            >
              キャンセル
            </Button>
            <Button
              onClick={() => {
                if (mfaSetting === 'enabled') {
                  enableMfa();
                  mfa_enable_success_toast();
                } else {
                  disableMfa(user.data?.id);
                  mfa_disable_success_toast();
                }
                queryClient.invalidateQueries({
                  queryKey: ['user/list', { tenant_id: tenant.tenantId }],
                });
                onPasswordChangeFormModalClose();
              }}
              colorScheme="blue"
            >
              設定
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
